<template>
<!--Modal that displays the download form-->
 <b-modal
    :id="`${chartId}-download-form`"
    size="md"
    :title="`UUID: ${chartId}`"
    header-class="download-header"
    body-class="download-body"
    content-class="download-modal-content"
    hide-footer
    centered
    v-model="modalShow"
  >
    <b-container fluid style="padding: 0">
      <b-row>
        <b-col cols="12">
          <b-form>
            <!--Download Data Type Radio Button-->
            <b-form-group
              horizontal
              id="dataType"
              label="Data Types: "
              label-size="lg"
              label-for="inputDataType"
              label-class="font-weight-bold pt-0"
            >
              <b-form-radio-group
                id="inputDataType"
                buttons
                button-variant="info"
                v-model="selectedDataType"
                :options="dataOptions"
              ></b-form-radio-group>
            </b-form-group>

            <!--Download File Type Radio Button-->
            <b-form-group
              horizontal
              id="dataFileType"
              label="Data File Type: "
              label-size="lg"
              label-for="inputDataFileType"
              label-class="font-weight-bold pt-0"
            >
              <b-form-radio-group
                id="inputDataFileType"
                buttons
                button-variant="info"
                v-model="selectedFileType"
                :options="fileOptions"
              ></b-form-radio-group>
            </b-form-group>
            <b-row>
              <b-col cols="12">
                <b-btn
                  block
                  variant="success"
                  v-on:click="submitForm"
                >Download File</b-btn>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { DateTime, Duration } from 'luxon';
import { mapActions } from 'vuex';
import { decode } from '@msgpack/msgpack';
import { APIBASEURL, APIDATA } from '@/utils/constants';

export default {
  props: ['chartId', 'chart', 'traceId', 'trace'],
  data() {
    return {
      requestBody: {},
      modalShow: false,
      dataStatus: '',
      dataMsg: 'Starting data download',
      fileURL: '',
      // Download File Type
      selectedFileType: 'csv', // default is CSV
      fileOptions: [
        { text: 'CSV', value: 'csv' },
        { text: 'NetCDF', value: 'netcdf' },
      ],
      // Download Data Type
      selectedDataType: 'undecimated', // default is the raw data
      dataOptions: [
        { text: 'Undecimated', value: 'undecimated' },
        // { text: 'Decimated', value: 'decimated', disabled: true },
      ],
    };
  },
  methods: {
    ...mapActions('visualization/traces', ['updateTrace']),
    async buildRequest() {
      return {
        ...this.chart.lastRequestParams,
        download: true,
        download_format: this.selectedFileType,
      };
    },
    /**
     * Async post method to start data request
     * @param {object} data - Request body for /data post
     */
    async postDataRequest(data) {
      return axios.post(`${APIBASEURL}/${APIDATA}/`, data);
    },
    async getDataRequest(uuid) {
      const getURL = `${APIBASEURL}/${APIDATA}/job/${uuid}`;
      return axios.get(getURL, {
        params: {
          version: '2.1',
        },
        responseType: 'arraybuffer',
        transformResponse: [(data) => decode(data)],
      });
    },
    // getData(jobUUID, startTime = null) {
    //   this.interval = setInterval(async () => {
    //     await this.performGetData(jobUUID, startTime, this.interval);
    //   }, 5000); // check data status every 5 seconds
    // },
    async submitForm() {
      this.requestBody = await this.buildRequest();
      this.modalShow = false;

      /** Sets value to true so DownloadAlert will popup */
      this.updateTrace({
        id: this.traceId,
        updateObj: {
          downloadAlertValue: true,
        },
      });

      const startTime = DateTime.utc();
      const data = this.requestBody;
      this.holdData = await this.postDataRequest(data);
      const jobUUID = this.holdData.data.job_uuid;
      // Passes through jobUUID from post response
      this.getDownload(jobUUID, startTime);
    },
    async performGetDownload(jobUUID, startTime = null, interval = null) {
      const endTime = DateTime.utc();
      this.timeElapsed = Duration.fromMillis(endTime - startTime).toISOTime();
      try {
        const response = await this.getDataRequest(jobUUID);
        const responseData = response.data;

        switch (responseData.status) {
          /** Job completed */
          case 'completed':
            /** @todo Need to workout multiple traces */
            this.updateTrace({
              id: this.traceId,
              updateObj: {
                downloadResponse: responseData,
                downloadAlertValue: true,
              },
            });
            // eslint-disable-next-line no-console
            console.log(`Data request status: ${responseData.status}`);
            // eslint-disable-next-line no-console
            console.log(`Data request msg: ${responseData.msg}`);
            clearInterval(interval);
            break;
          /** Job failed */
          case 'failed':
            // eslint-disable-next-line no-console
            console.log(`Data request status: ${responseData.status}`);
            // eslint-disable-next-line no-console
            console.log(`Data request msg: ${responseData.msg}`);
            clearInterval(interval);
            break;
          /** Job exception */
          case 'job-exception':
            // eslint-disable-next-line no-console
            console.log(`Data request status: ${responseData.status}`);
            // eslint-disable-next-line no-console
            console.log(`Data request msg: ${responseData.msg}`);
            clearInterval(interval);
            break;
          /**
           * Default when status is 'started' or 'pending'
           *
           * @todo Add check for data.request.msg that indicates the request is
           * stuck - "Something is wrong on our end. Please try again later."
           */
          default:
            // eslint-disable-next-line no-console
            console.log(`Data request status: ${responseData.status}`);
            // eslint-disable-next-line no-console
            console.log(`Data request msg: ${responseData.msg}`);
            this.updateTrace({
              id: this.traceId,
              updateObj: {
                downloadResponse: responseData,
              },
            });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    getDownload(jobUUID, startTime = null) {
      this.interval = setInterval(async () => {
        await this.performGetDownload(jobUUID, startTime, this.interval);
      }, 5000); // check data status every 5 seconds
    },
  },
};
</script>

<style>

</style>
